import React from 'react'
import { Link } from 'react-router-dom'
import { WrapperImg } from '../../components/WrapperImg/WrapperImg'
import ROUTES from '../../routers/routes'

import './Construction.scss'

export const Construction = () => {
  return (
    <section>
      <WrapperImg imgName="Setting" title="En Construcción" text="">
        <Link to={ROUTES.HOME.pathname}>Regresar a Home</Link>
      </WrapperImg>
    </section>
  )
}
